<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
        // @ts-ignore
        layout: (h, page) =>
            h(AppLayout, { classList: 'flex' }, () => h(ErrorLayout, page.props, () => page)),
    });
</script>
<script setup lang="ts">
    import AppLayout from '@/views/layouts/App/Main.vue'
    import ErrorLayout from '@/views/layouts/Error.vue'

    
</script>
